module.exports = __webpack_public_path__ + "img/link-2-outline.png";